import { render, staticRenderFns } from "./AiInsightsPanel.vue?vue&type=template&id=0228bc10&scoped=true"
import script from "./AiInsightsPanel.vue?vue&type=script&lang=js"
export * from "./AiInsightsPanel.vue?vue&type=script&lang=js"
import style0 from "./AiInsightsPanel.vue?vue&type=style&index=0&id=0228bc10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0228bc10",
  null
  
)

export default component.exports